import { useQuery } from '@tanstack/react-query';

import { getAttraction } from '~/services/AttractionsService';

import { attractionQueryKeys } from './attractionQueryKeys';

/**
 * Fetches a single attraction by ID via GET /attractions/:attractionId.
 */
export function useGetAttraction(attractionId: string) {
  return useQuery({
    queryKey: attractionQueryKeys.detail(attractionId),
    queryFn: async ({ signal }) => {
      const response = await getAttraction(attractionId, { signal });
      return response.result ?? null;
    },
    enabled: !!attractionId,
    retry: false,
  });
}
